<template>
  <div class="header">
    <!-- Logo (po kliknięciu przenosi na stronę główną) -->
    <div :class="['logo', { 'logo--sg': shouldHideLocation }]">
      <router-link to="/"></router-link>
    </div>
    <div :class="['banner', { 'banner--sg': isSG, 'banner--posg': isPOSG, 'banner--nosg': isNOSG }]"></div>
    <div class="additional-menu">
      <!-- Widget feedback  (np. zgłaszanie błędów) -->
<!--      <div id="feedback-form" v-if="hasAccess('Tickets')"></div>-->
      <div class="d-flex">
        <!-- Ikona zgłaszania problemu (report), widoczna tylko dla uprawnionych -->
        <span
          class="report"
          @click="openReportModal"
          v-if="hasAccess('Tickets') && !shouldHideLocation"
          :title="t('open-report-form')"
        >!</span>
        <!-- Ikona głośności: pozwala włączać/wyłączać dźwięki nowego pojazdu -->
        <span
          class="volume"
          :class="{ 'is-mute': this.mute }"
          @click="toggleVolume(this.mute)"
          :title="t('mute-new-vehicle-sound')"
        ></span>
        <!-- Przejście do ustawień/prerferencji użytkownika -->
        <router-link
          class="settings"
          to="/preference"
          :title="t('settings')"
        ></router-link>
        <!-- <router-link v-if="hasAccess('UsersAdmin')" class="users" to="/users"
          >{{ hasAccess("UsersAdmin") ? "" : "Użytkownicy" }}
        </router-link> -->
        <!-- Wylogowanie -->
        <router-link class="logout" to="/logout">{{ t('logout') }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { useUserStore } from "@/stores/user.store";
import CurrentMeasurementsService from "@/services/CurrentMeasurementsService";
import { isSG, isNOSG, isPOSG } from "@/config/appVersion";
import { computed } from "vue";
import { i18n} from "@/main";
import {useI18n} from "vue-i18n";

export default {
  setup() {
    const shouldHideLocation = computed(() => {
      return isSG;
    });

    const userStore = useUserStore();

    const { t } = useI18n();

    return { shouldHideLocation, userStore, t, isSG, isNOSG, isPOSG };
  },
  data() {
    return {
      mute: false, // czy dźwięk nowego pojazdu jest wyciszony?
      vehService: CurrentMeasurementsService, // dostęp do obsługi dźwięku
    };
  },
  methods: {
    // Sprawdza, czy aktualny użytkownik ma dany typ dostępu (np. do , ustawień, itp.)
    hasAccess(id) {
      return this.userStore.hasAccess(id);
    },
    // Przełącza wyciszenie dźwięków
    toggleVolume(flag) {
      this.mute = !flag;
      this.vehService.beepToggle(this.mute);
    },
    // Otwiera modal zgłoszenia (po kliknięciu „!”, jeśli uprawnienia pozwalają).
    // Sam formularz (wraz z wysyłką przez TicketsService) jest w TicketModal.vue —
    // tutaj podajemy wyłącznie tytuł okna.
    openReportModal() {
      window.$modal.showModal(i18n.global.t('report-error'));
    },
  },
};
</script>

<style scoped>
/* Pasek marki: logo (lewa kolumna) — baner — akcje użytkownika.
   Szerokość logo to ta sama wartość co sidebar i strefa lewej kolumny w pasku
   nawigacji (`--left-column-width`), dzięki czemu wszystkie te krawędzie leżą
   na jednej osi. Wysokość odczytana z referencji proporcji. */
.header {
  display: flex;
  align-items: stretch;
  min-height: 156px;
  background-color: var(--surface-secondary);
  border-bottom: 1px solid var(--border-default);
}

.logo {
  flex: 0 0 var(--left-column-width);
  width: var(--left-column-width);
  min-width: 0;
  position: relative;
  background: var(--surface-secondary) url("../assets/logo.png") no-repeat center;
  background-size: auto 44%;
  border-right: 1px solid var(--border-default);
}

.logo a {
  display: block;
  width: 100%;
  height: 100%;
}

.logo--sg {
  background: var(--surface-secondary) url("../assets/best2.png") no-repeat center;
}

.banner {
  flex: 1 1 auto;
  min-width: 0;
  background: var(--surface-secondary) url("../assets/baner5.jpg") no-repeat left center;
  background-size: auto 100%;
}

.banner--sg,
.banner--nosg {
  background: var(--surface-secondary) url("../assets/baner8.jpeg") no-repeat left center;
  background-size: auto 100%;
}

.banner--posg {
  background: var(--surface-secondary) url("../assets/baner7.jpeg") no-repeat left center;
  background-size: auto 100%;
}

/* --- akcje użytkownika ----------------------------------------------------
   Wszystkie akcje mają tę samą wysokość i taki sam obszar klikalny, a jedynym
   separatorem jest lewa krawędź kolejnego elementu. Wymiary nie zmieniają się
   na hover, więc pasek nie „drga" i nie ma przypadkowych krótkich kresek. */

.additional-menu {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  padding: var(--spacing-md) var(--spacing-lg);
}

.additional-menu > div {
  display: flex;
  align-items: stretch;
  gap: 0;
  margin: 0;
  border: 1px solid var(--border-default);
  border-radius: var(--control-radius);
  background: var(--surface-primary);
  overflow: hidden;
}

/* Wspólna geometria pojedynczej akcji */
.report,
.volume,
.settings,
.logout {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  min-width: 44px;
  height: 34px;
  padding: 0 var(--spacing-sm);
  border: 0;
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
  text-decoration: none;
  cursor: pointer;
  transition: background-color var(--transition-fast), color var(--transition-fast);
}

/* Separator = krawędź kolejnej akcji (żadnych osobnych kresek) */
.additional-menu > div > *:not(:first-child) {
  border-left: 1px solid var(--border-default);
}

.report:hover,
.volume:hover,
.settings:hover,
.logout:hover {
  background: var(--surface-hover);
  color: var(--text-primary);
  text-decoration: none;
}

.report:focus-visible,
.volume:focus-visible,
.settings:focus-visible,
.logout:focus-visible {
  outline: 2px solid var(--border-focus);
  outline-offset: -2px;
}

/* Ikony jako tło wyśrodkowane w stałym obszarze — bez zmiany wymiarów na hover */
.settings::before,
.volume::before {
  content: "";
  width: 22px;
  height: 22px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 22px 22px;
}

.settings::before {
  background-image: url("../assets/icons/preferencje.png");
}

.settings:hover::before {
  background-image: url("../assets/icons/preferencje_over.png");
}

.volume::before {
  background-image: url("../assets/icons/volume-up.svg");
  filter: invert(38%) sepia(5%) saturate(178%) hue-rotate(201deg) brightness(83%)
    contrast(85%);
}

.volume.is-mute::before {
  background-image: url("../assets/icons/volume-mute.svg");
}

.logout {
  gap: var(--spacing-sm);
  padding: 0 var(--spacing-md);
  font-weight: var(--font-weight-medium);
  white-space: nowrap;
}

.logout::before {
  content: "";
  width: 22px;
  height: 22px;
  background: url("../assets/icons/wyloguj.png") no-repeat center;
  background-size: 22px 22px;
}

.logout:hover::before {
  background-image: url("../assets/icons/wyloguj_over.png");
}

/* Ikona zgłoszenia błędu — znak „!” zamiast obrazka */
.report {
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-md);
}
</style>
